import React from 'react';
import { ContextRecommendations } from '@alfa-bank/newclick-composite-components/context-recommendations';
import cn from 'classnames';
import { useAtomValue } from 'jotai';

import { PureCell } from '@alfalab/core-components/pure-cell';

import { poolInfoAtom } from '../../atoms/money-pool-data/atom';
import { platformAtom } from '../../atoms/platform/atom';
import { TransferInput } from '../transfer-input';

import styles from './index.module.css';

export const MoneyPoolInfo = () => {
    const platform = useAtomValue(platformAtom);

    const { ownerText, comment, closedPool } = useAtomValue(poolInfoAtom);

    return (
        <React.Fragment>
            <PureCell className={styles.cell} dataTestId='pool-owner-cell'>
                <PureCell.Content>
                    <PureCell.Main>
                        <PureCell.Text titleColor='secondary' view='primary-small'>
                            Организатор
                        </PureCell.Text>
                        <PureCell.Text titleColor='primary' view='primary-medium'>
                            {ownerText}
                        </PureCell.Text>
                    </PureCell.Main>
                </PureCell.Content>
            </PureCell>
            {comment && (
                <PureCell className={styles.cell} dataTestId='pool-comment-cell'>
                    <PureCell.Content>
                        <PureCell.Main>
                            <PureCell.Text titleColor='secondary' view='primary-small'>
                                Комментарий
                            </PureCell.Text>
                            <PureCell.Text titleColor='primary' view='primary-medium'>
                                {comment}
                            </PureCell.Text>
                        </PureCell.Main>
                    </PureCell.Content>
                </PureCell>
            )}
            {closedPool ? (
                <ContextRecommendations
                    dataTestId='closed-info'
                    type='no-click'
                    className={cn(styles.closedPool, styles[platform])}
                    icon={closedPool.iconUrl}
                    title={closedPool.title}
                />
            ) : (
                <TransferInput />
            )}
        </React.Fragment>
    );
};
